'use strict';

var React = require('react');

var SvgTransferWithinShopifyMajor = function SvgTransferWithinShopifyMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m7 2.202 2.801 1.868-3.331 2.082a1 1 0 0 0-.47.848v2h2v-1.446l5-3.125 5 3.125v10.446h-10v-3h-2v3.5a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5v-11.5a1 1 0 0 0-.47-.848l-6-3.75a1.003 1.003 0 0 0-1.06 0l-.807.505-4.108-2.739a1 1 0 0 0-1.11 0l-6 4a1.001 1.001 0 0 0-.445.832v13h2v-12.465l5-3.333zm-2 10.798h6.586l-1.293 1.293a1 1 0 1 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 1 0-1.414 1.414l1.293 1.293h-6.586a1 1 0 0 0 0 2z"
  }));
};

exports.SvgTransferWithinShopifyMajor = SvgTransferWithinShopifyMajor;
